import JoditEditor from "jodit-react";
import { useEffect, useState } from "react";
import {
  Col,
  FloatingLabel,
  Form,
  FormControl,
  InputGroup,
  Row,
} from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

const ShippingAndWarrantyInfo = () => {
  const {
    register,
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { pathname, state } = useLocation();
  const navigate = useNavigate();

  const [volumeUOM, setVolumeUOM] = useState(watch("volumeUOM") || "cm");

  // Handle volumeUOM change for all selects
  const handleVolumeUOMChange = (e) => {
    const value = e.target.value;
    setVolumeUOM(value);
    setValue("volumeUOM", value); // update the form value
  };

  useEffect(() => {
    register("insideBox");
  }, [register]);

  useEffect(() => {
    if (state) {
      setValue("insideBox", state.insideBox || "");
    }
  }, [state, setValue]);

  return (
    <>
      {/* <Card.Header as="h6" className="bg-body-tertiary mb-2">
        Shipping And Warranty
      </Card.Header> */}
      <Row className="gx-1 gy-1">
        {/* <Col md="6">


          <InputGroup>
            <FormControl
              style={{ width: "80%" }}
              placeholder="Weight"
              title="Weight"
              type="number"
              isInvalid={!!errors?.weight}
              {...register("weight")}
              aria-label="Text input with dropdown button"
            />
            <Form.Select
              style={{
                appearance: "none", // Removes default arrow in most browsers
                MozAppearance: "none", // Firefox
                WebkitAppearance: "none", // Safari/Chrome
                background: "none", // Removes default background, if needed
              }}
              className=" px-1 fs-10"
              aria-label="Default select example"
              isInvalid={!!errors?.weightUOM}
              {...register("weightUOM")}
            >
              <option value="kg">kg</option>
              <option value="lbs">lbs</option>
              <option value="g">g</option>
            </Form.Select>
          </InputGroup>
        </Col> */}
        {/* <Col md="6">
          <div className="d-flex align-items-center">
            <InputGroup>
              <FormControl
                style={{ width: "40%" }}
                placeholder="Length"
                title="Length"
                type="number"
                aria-label="Text input with dropdown button"
                isInvalid={!!errors?.length}
                {...register("length")}
              />
              <Form.Select
                style={{
                  appearance: "none", // Removes default arrow in most browsers
                  MozAppearance: "none", // Firefox
                  WebkitAppearance: "none", // Safari/Chrome
                  background: "none", // Removes default background, if needed
                }}
                className="px-1 fs-10"
                // aria-label="Default select example"
                isInvalid={!!errors?.volumeUOM}
                value={volumeUOM}
                onChange={handleVolumeUOMChange}
              >
                <option value="cm">cm</option>
                <option value="mm">mm</option>
                <option value="m">m</option>
              </Form.Select>
            </InputGroup>
            <span className="px-1">x</span>
            <InputGroup>
              <FormControl
                style={{ width: "40%" }}
                placeholder="Width"
                title="Width"
                type="number"
                aria-label="Text input with dropdown button"
                isInvalid={!!errors?.width}
                {...register("width")}
              />
              <Form.Select
                style={{
                  appearance: "none", // Removes default arrow in most browsers
                  MozAppearance: "none", // Firefox
                  WebkitAppearance: "none", // Safari/Chrome
                  background: "none", // Removes default background, if needed
                }}
                className="px-1 fs-10"
                aria-label="Default select example"
                isInvalid={!!errors?.volumeUOM}
                value={volumeUOM}
                onChange={handleVolumeUOMChange}
              >
                <option value="cm">cm</option>
                <option value="mm">mm</option>
                <option value="m">m</option>
              </Form.Select>
            </InputGroup>
            <span className="px-1">x</span>
            <InputGroup>
              <FormControl
                style={{ width: "40%" }}
                placeholder="Height"
                title="Height"
                type="number"
                aria-label="Text input with dropdown button"
                isInvalid={!!errors?.height}
                {...register("height")}
              />
              <Form.Select
                style={{
                  appearance: "none", // Removes default arrow in most browsers
                  MozAppearance: "none", // Firefox
                  WebkitAppearance: "none", // Safari/Chrome
                  background: "none", // Removes default background, if needed
                }}
                className="px-1 fs-10"
                aria-label="Default select example"
                isInvalid={!!errors?.volumeUOM}
                value={volumeUOM}
                onChange={handleVolumeUOMChange}
              >
                <option value="cm">cm</option>
                <option value="mm">mm</option>
                <option value="m">m</option>
              </Form.Select>
            </InputGroup>
          </div>
        </Col> */}

        <Col md="6">
          <Form.Group>
            <InputGroup>
              <FloatingLabel label="Weight" className="flex-grow-1">
                <Form.Control
                  type="number"
                  placeholder=" "
                  isInvalid={!!errors?.weight}
                  {...register("weight")}
                />

                <Form.Control.Feedback type="invalid">
                  {errors?.weight?.message}
                </Form.Control.Feedback>
              </FloatingLabel>

              <Form.Select
                className="px-3 fs-10"
                isInvalid={!!errors?.weightUOM}
                {...register("weightUOM")}
                style={{
                  appearance: "none",
                  maxWidth: "90px",
                  maxHeight: "58px",
                }}
              >
                <option value="kg">kg</option>
                <option value="lbs">lbs</option>
                <option value="g">g</option>
              </Form.Select>
            </InputGroup>
          </Form.Group>
        </Col>

        <Col md="6">
          <div className="d-flex align-items-start">
            {/* Length */}
            <InputGroup>
              <FloatingLabel label="Length" className="flex-grow-1">
                <Form.Control
                  type="number"
                  placeholder=" "
                  isInvalid={!!errors?.length}
                  {...register("length")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors?.length?.message}
                </Form.Control.Feedback>
              </FloatingLabel>

              <Form.Select
                className="px-3 fs-10"
                value={volumeUOM}
                onChange={handleVolumeUOMChange}
                style={{
                  appearance: "none",
                  maxWidth: "90px",
                  maxHeight: "58px",
                }}
              >
                <option value="cm">cm</option>
                <option value="mm">mm</option>
                <option value="m">m</option>
              </Form.Select>
            </InputGroup>

            <span className="px-1 pt-3">×</span>

            {/* Width */}
            <InputGroup>
              <FloatingLabel label="Width" className="flex-grow-1">
                <Form.Control
                  type="number"
                  placeholder=" "
                  isInvalid={!!errors?.width}
                  {...register("width")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors?.width?.message}
                </Form.Control.Feedback>
              </FloatingLabel>

              <Form.Select
                className="px-3 fs-10"
                value={volumeUOM}
                onChange={handleVolumeUOMChange}
                style={{
                  appearance: "none",
                  maxWidth: "90px",
                  maxHeight: "58px",
                }}
              >
                <option value="cm">cm</option>
                <option value="mm">mm</option>
                <option value="m">m</option>
              </Form.Select>
            </InputGroup>

            <span className="px-1 pt-3">×</span>

            {/* Height */}
            <InputGroup>
              <FloatingLabel label="Height" className="flex-grow-1">
                <Form.Control
                  type="number"
                  placeholder=" "
                  isInvalid={!!errors?.height}
                  {...register("height")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors?.height?.message}
                </Form.Control.Feedback>
              </FloatingLabel>

              <Form.Select
                className="px-3 fs-10"
                value={volumeUOM}
                onChange={handleVolumeUOMChange}
                style={{
                  appearance: "none",
                  maxWidth: "90px",
                  maxHeight: "58px",
                }}
              >
                <option value="cm">cm</option>
                <option value="mm">mm</option>
                <option value="m">m</option>
              </Form.Select>
            </InputGroup>
          </div>
        </Col>

        <Col md="6">
          <Form.Group>
            <FloatingLabel label="Warranty">
              <Form.Select
                placeholder=" "
                isInvalid={!!errors?.warranty}
                {...register("warranty")}
              >
                <option value="">Select Warranty</option>
                <option value="Seller Warranty">Seller Warranty</option>
                <option value="No Warranty">No Warranty</option>
              </Form.Select>
            </FloatingLabel>
          </Form.Group>
        </Col>

        <Col md="6">
          <Form.Group>
            <FloatingLabel label="Warranty Type">
              <Form.Control
                type="text"
                placeholder=" "
                isInvalid={!!errors?.warrantyType}
                {...register("warrantyType")}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.warrantyType?.message}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
        </Col>

        <Col md="6">
          <Form.Group>
            <FloatingLabel label="Warranty Period">
              <Form.Select
                placeholder=" "
                isInvalid={!!errors?.warrantyPeriod}
                {...register("warrantyPeriod")}
              >
                <option value="">Select Period</option>
                {[...Array(12)].map((_, i) => (
                  <option key={i} value={`${i + 1} Month`}>
                    {i + 1} Month
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Form.Group>
        </Col>

        <Col md="6">
          <Form.Group>
            <FloatingLabel label="Warranty Policy">
              <Form.Control
                type="text"
                placeholder=" "
                isInvalid={!!errors?.warrantyPolicy}
                {...register("warrantyPolicy")}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.warrantyPolicy?.message}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
        </Col>

        <Col md={12}>
          <Form.Label>What's Inside the Box?</Form.Label>
          {/* <QuillEditor
                  setValue={(value) => setValue("insideBox", value)} // Sync with react-hook-form
                  value={watch("insideBox")} // Get the value from react-hook-form
                /> */}
          <JoditEditor
            config={{
              showCharsCounter: false,
              showWordsCounter: false,
              showXPathInStatusbar: false, // ✅ Removes footer bar
              buttons: [
                "source",
                "bold",
                "italic",
                "underline",
                "strikethrough",
                "superscript",
                "subscript",
                "ul",
                "ol",
                "indent",
                "font",
                "fontsize",
                "brush",
                "paragraph",
                "align",
                "hr",
                "eraser",
                "copyformat",
                "symbol",
                "fullsize",
                "print",
                "about",
                "selectall",
                // "copy",
                // "paste",
                "link",
                "unlink",
                "image",
                "file",
                "video",
                "table",
                "preview",
                "dots", // Dots button expands extra options
              ],
              placeholder: "Inside Box",
              toolbarAdaptive: false, // Show full toolbar without collapsing
              toolbarSticky: false, // Keep toolbar fixed when scrolling
              uploader: {
                insertImageAsBase64URI: true, // ✅ Allows adding Base64 images directly
              },
              readonly: false,
              askBeforePasteHTML: false,
              askBeforePasteFromWord: false,
              pasteHTMLAction: "insert_as_html",
              pasteFromWordAction: "insert_as_html",
              enableDragAndDropFileToEditor: true,
            }}
            value={watch("insideBox")} // ✅ Watch ensures form binding
            onBlur={(value) => {
              const cleanValue = value
                .replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/g, "")
                .trim();

              setValue("insideBox", cleanValue);
            }}
            // onBlur={(value) => setValue("insideBox", value)} // preferred to use only this option to update the content
          />
        </Col>
      </Row>
    </>
  );
};

export default ShippingAndWarrantyInfo;
